import {createApp} from 'vue';

import ProjectPage from './layout';

const app = createApp({
  components: {
    'project-page': ProjectPage
  }
}).mount('#body-of-page-project');


window.projectIndex = function (_data) {
  "use strict";
  window.data = _data;
}
